const ODOO_TAG_COLORS = {
  0: "#94A3B8",
  1: "#EF4444",
  2: "#F97316",
  3: "#EAB308",
  4: "#64748B",
  5: "#475569",
  6: "#FB7185",
  7: "#3B82F6",
  8: "#CBD5E1",
  9: "#D946EF",
  10: "#10B981",
  11: "#8B5CF6",
};

export function odooTagColor(colorIndex) {
  if (typeof colorIndex !== "number") return "#F37021";
  return ODOO_TAG_COLORS[colorIndex] ?? "#F37021";
}

export function formatMoney(amount, currency = "USD") {
  if (typeof amount !== "number") return "—";
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
}

export function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
}
